import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title = 'UrbanHive - Apiculture Urbaine & Ruches de Balcon',
  description = 'Guide complet pour débuter l\'apiculture urbaine. Apprenez à installer une ruche sur votre balcon, respecter la réglementation et récolter votre miel.',
  keywords = 'apiculture urbaine, ruche balcon, apiculture ville, miel urbain, abeilles ville, ruche urbaine, apiculture débutant',
  image = 'https://urban-hive.fr/images/ruche-balcon.png',
  url = '',
  type = 'website',
  author = 'UrbanHive',
  locale = 'fr_FR'
}) => {
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://urban-hive.fr';
  const canonicalUrl = `${siteUrl}${url}`;

  return (
    <Helmet>
      {/* Titre et description de base */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content="UrbanHive" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Informations supplémentaires */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="French" />
      <meta name="revisit-after" content="7 days" />

      {/* PWA et mobile */}
      <meta name="theme-color" content="#F6C90E" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="UrbanHive" />

      {/* Structured Data JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "UrbanHive",
          "description": description,
          "url": siteUrl,
          "publisher": {
            "@type": "Organization",
            "name": "UrbanHive",
            "logo": {
              "@type": "ImageObject",
              "url": `${siteUrl}/images/bee-icon.png`
            }
          }
        })}
      </script>
    </Helmet>
  );
};
